import { EGButton, type EGButtonVariant } from '@/components/eg/eg-button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

interface EGDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  primaryMessage?: string;
  secondaryMessage?: string;
  actionLabel: string;
  actionVariant?: EGButtonVariant;
  cancelLabel?: string;
  buttonsDisabled?: boolean;
  loading?: boolean;
  onAction: () => void;
  className?: string;
}

export function EGDialog({
  open,
  onOpenChange,
  primaryMessage,
  secondaryMessage,
  actionLabel,
  actionVariant = 'primary',
  cancelLabel,
  buttonsDisabled = false,
  loading = false,
  onAction,
  className,
}: EGDialogProps) {
  const isDisabled = buttonsDisabled || loading;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn('rounded-3xl border-none sm:max-w-lg', className)}>
        <DialogHeader>
          <DialogTitle className="sr-only">{actionLabel}</DialogTitle>
        </DialogHeader>

        <div>
          {primaryMessage && <p className="text-lg font-semibold">{primaryMessage}</p>}
          {secondaryMessage && <p className="text-muted-foreground mt-2 text-sm">{secondaryMessage}</p>}
        </div>

        <DialogFooter className="gap-4">
          {cancelLabel && (
            <EGButton
              egVariant="secondary"
              egSize="sm"
              label={cancelLabel}
              onClick={() => onOpenChange(false)}
              disabled={isDisabled}
            />
          )}
          <EGButton
            egVariant={actionVariant}
            egSize="sm"
            label={actionLabel}
            onClick={onAction}
            disabled={isDisabled}
            loading={loading}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default EGDialog;
